var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgQuestionAnswerLine = function SvgQuestionAnswerLine(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M5.091 12.25 1.75 14.875V3.25a.75.75 0 0 1 .75-.75h11.25a.75.75 0 0 1 .75.75v9zm-.519-1.5H13V4H3.25v7.789zm2.428 3h7.678L16 14.789V7h.75a.75.75 0 0 1 .75.75v10.125l-3.341-2.625H7.75A.75.75 0 0 1 7 14.5z"
  })));
};
export default SvgQuestionAnswerLine;